import React, { useEffect, useMemo, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { getGTMVariables, getGTMVariablesPageView, getEncryptedValue  } from 'common/helpers/Gtm';
import { RegisterMethod } from 'common/consts/GtmVariableValues';
import TagManager from 'react-gtm-module';
import DebtOverviewPageDataSecured from './DebtOverViewPageDataSecured';
import DebtOverviewPageData from './DebtOverviewPageData';

interface Props {
    PageData?: any;
    Model?: any;
    LayoutModel?: any;
  }

  const DebtOverviewPageDataSelector = (props: Props) => {
    const history = useHistory();
    const { Model, PageData, LayoutModel } = props;
    
    const [eventTracked, setEventTracked] = useState<boolean>(false);
   
    useEffect(() => {
      if (LayoutModel != undefined) {
        var userid = LayoutModel?.Profiles.length > 0 ? LayoutModel?.Profiles[0].DebtReference : '';
        var isLoggedIn = LayoutModel?.HasProfile;
        var lang = PageData?.Language;
        var env = LayoutModel?.Environment;
        var reg = LayoutModel?.CountryCode;
        getGTMVariables(userid, isLoggedIn, lang, reg, env, Model?.IsSecuredUser,Model?.SecuredStatus);
        getGTMVariablesPageView(window.document.title, window.location.href, window.location.pathname, userid, isLoggedIn, lang, reg, env);
      }
    }
      , [LayoutModel]);
  
  
    useEffect(() => {
      var tagManagerArgs: any;
      if (eventTracked == false) {
        if (Model?.FirstSuccessfulLogin) {
          let register_method: string = '';
          if (Model?.userId) {
            if (Model?.userId?.includes("google")) {
              register_method = RegisterMethod.Google;
            }
            else if (Model?.userId?.includes("apple")) {
              register_method = RegisterMethod.Apple;
            }
            else {
              register_method = RegisterMethod.Email;
            }
          }
          let encodedUserId = getEncryptedValue(Model?.DebtReference,LayoutModel?.CountryCode)
          tagManagerArgs = {
            dataLayer: {
              event: 'register',
              checkout_name: 'Registration',
              register_method: register_method,
              user_id: encodedUserId,
              is_secured_user: Model?.IsSecuredUser,
              ...(Model?.IsSecuredUser && {secured_case_status : Model?.SecuredStatus} )
            }
          };
          TagManager.dataLayer(tagManagerArgs);
          setEventTracked(true);
        };
      };
    }, [Model?.FirstSuccessfulLogin]);
    return (
    <>
        {Model?.IsSecuredUser ? (<DebtOverviewPageDataSecured {...props}/> ) : 
        (<DebtOverviewPageData {...props}/>)}
    </>
    );
  };
    export default DebtOverviewPageDataSelector;
  